import { useState } from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import {
  useGetOnboardingQuery,
  useMarkHintSeenMutation,
} from "../../../store/apiSlice/onboardingApiSlice";
import { useOptionalSetupGuide } from "../SetupGuideContext";
import { GuideHint } from "./GuideHint";

/**
 * Shows a screen's tips the first time a person opens it, then never again on
 * any device. Stays quiet while the setup guide or a guided link is running,
 * and when the person has switched tips off.
 *
 * @param {{hintKey: string}} props A `screen.*` key from the hint registry.
 */
export function FirstVisitHint({ hintKey }) {
  const companyId = useSelector(
    state => state.auth?.user?.company_id ?? state.auth?.user?.company?.id,
  );
  const setupGuide = useOptionalSetupGuide();
  const [searchParams] = useSearchParams();
  const { data } = useGetOnboardingQuery(undefined, { skip: !companyId });
  const [markHintSeen] = useMarkHintSeenMutation();
  const [done, setDone] = useState(false);

  const preferences = data?.preferences;
  const quiet =
    done ||
    !preferences ||
    preferences.hints_disabled ||
    (preferences.seen_hints || []).includes(hintKey) ||
    setupGuide?.drawerOpen ||
    Boolean(searchParams.get("guide"));

  if (quiet) return null;

  return (
    <GuideHint
      guideKey={hintKey}
      onDone={() => {
        setDone(true);
        markHintSeen(hintKey);
      }}
    />
  );
}
